import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "img-container",
  id: "img-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "error"
}
const _hoisted_4 = {
  key: 2,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.imgurl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: $setup.imgurl,
          alt: "Image"
        }, null, 8, _hoisted_2))
      : ($setup.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Unable to load image: " + _toDisplayString($setup.error), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading..."))
  ]))
}